export const PREFIX = "pop-up-manager";
